import * as React from 'react'
import {Routes, Route, useLocation} from 'react-router-dom'
import {BusinessResults} from './screens/business-results'
import {LoginRedirect} from './login-redirect-app'
import {HeaderTitle} from './components/header-title'
import NotFoundPage from './components/not-found-page'
import {ToastContainer} from 'react-toastify'
import {PaymentInformationProvider} from './components/payment-information-components/contexts/payment-information-provider'
import {PaymentAuthProvider} from './components/payment-information-components/contexts/payment-auth-context'
import {PaymentInformationGate} from './components/payment-information-components/payment-information-gate'
import {SuccessAcknowledge} from './screens/success-acknowledge'
import {ClientProposalView} from './pages/ProposalTool/features/ClientProposalView'
import {
  ClientProposalViewAuth,
  ProposalAuthProvider,
} from './pages/ProposalTool/features/ClientProposalFlow'
import {ProposalAccountInformation} from './pages/ProposalTool/features/ClientProposalFlow/account-information'
import {ClientProposalSchedule} from './pages/ProposalTool/features/ClientProposalSchedule'
import {ProposalPaymentView} from './pages/ProposalTool/features/ClientProposalFlow/client-payment'

function ProposalViewRoute() {
  const {state} = useLocation()
  return (
    <ProposalAuthProvider initialToken={state?.proposalAuthToken}>
      <ClientProposalView />
    </ProposalAuthProvider>
  )
}

function PaymentRoute() {
  const {state} = useLocation()
  const flowType = state?.flowType
  return (
    <>
      <PaymentAuthProvider flowType={flowType}>
        <PaymentInformationProvider>
          <PaymentInformationGate />
        </PaymentInformationProvider>
      </PaymentAuthProvider>
      <ToastContainer />
    </>
  )
}

function UnauthenticatedApp() {
  return (
    <Routes>
      <Route path="/scan-results/:recordId" element={<BusinessResults />} />
      <Route
        path="/payment-information/:randomId"
        element={
          <HeaderTitle title="Payment information">
            <PaymentRoute />
          </HeaderTitle>
        }
      />
      <Route
        path="/proposalLink/:randomId"
        element={
          <HeaderTitle title="Client Proposal View">
            <ClientProposalViewAuth />
            <ToastContainer />
          </HeaderTitle>
        }
      />
      <Route path="/success-acknowledge" element={<SuccessAcknowledge />} />
      <Route path="/payment-information" element={<NotFoundPage />} />
      <Route
        path="/proposal-view/:randomId/account-information"
        element={
          <ProposalAuthProvider>
            <ProposalAccountInformation />
          </ProposalAuthProvider>
        }
      />
      <Route
        path="/proposal-view/:proposalId/schedule-appointment"
        element={
          <ProposalAuthProvider>
            <ClientProposalSchedule />
          </ProposalAuthProvider>
        }
      />
      <Route
        path="/proposal-view/:randomId/client-payment"
        element={
          <ProposalAuthProvider>
            <PaymentInformationProvider>
              <ProposalPaymentView />
            </PaymentInformationProvider>
          </ProposalAuthProvider>
        }
      />
      <Route
        path="/proposal-view/:proposalId"
        element={<ProposalViewRoute />}
      />
      <Route path="*" element={<LoginRedirect />} />
    </Routes>
  )
}

export default UnauthenticatedApp
